import RightModal from "../templates/properties/partials/RightModal";
import { useT } from '../../helpers/i18n';
import ContentWrapper from "../templates/properties/partials/ContentWrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/pro-duotone-svg-icons/faSpinner";
import React, {FormEvent, useEffect, useState} from "react";
import {faLock as fasLock, faAngleRight as fasAngleRight, faAngleLeft as fasAngleLeft} from "@fortawesome/pro-solid-svg-icons";
import {validatePropertiesPassword} from "../../api/client";
import {useDispatch, useSelector} from "react-redux";
import {Alert} from "@mui/lab";
import {setPropertiesListPasswordConfirmed} from "../../redux/actions";
import Checkers from "../../helpers/class/Checkers";
import {fetchBuilderSettingByKey} from "../../helpers/MethodHelper";
import Link from "next/link";

const PasswordProtection = (props: any) => {
  const t = useT();

    const {
        pageId
    } = props

    const dispatch = useDispatch()

    const [modalState, setModalState] = useState("clode");

    const [formSubmitting, setFormSubmitting] = useState(false)

    const [showResponseMessage, setShowResponseMessage] = useState(false)

    const [formSuccess, setFormSuccess] = useState(null)

    const PASSWORD_CONFIRMED_KEY = `properties_password_confirmed_${pageId}`;

    const propertiesLockEnabled = useSelector(
        state => Checkers.valueToBoolean(fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_properties_lock'))
    );

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        event.stopPropagation()

        setFormSubmitting(true)

        let data = new FormData(event.currentTarget)
        let formObject = Object.fromEntries(data.entries());

        let response = await validatePropertiesPassword({'page_id': pageId}, formObject)

        setShowResponseMessage(true)

        if (response.success == 1) {
            setFormSuccess(true)
            sessionStorage.setItem(PASSWORD_CONFIRMED_KEY, '1')
            dispatch(setPropertiesListPasswordConfirmed(true))
        } else {
            setFormSuccess(false)
        }

        setFormSubmitting(false)
    }

    useEffect(() => {
        if (propertiesLockEnabled) {
            setModalState('password_modal')
        }
    }, []);

    return (
        <>
            <RightModal
                key={100}
                modalName={'password_modal'}
                className="stick-up"
                disableClose={true}
                Title={<><FontAwesomeIcon icon={fasLock} size="xs"/> {t('auth.areaProtected')}</>}
                modalSize="sm"
                loaderStatus={false}
                closeModal={() => {
                    // handleHide()
                }}
                show={modalState === 'password_modal'}
                BodyRender={<ContentWrapper ContentRender={
                    <>
                        <form onSubmit={handleSubmit}>
                            <div className="row m-t-20">
                                <div className="col-12 col-md-12 p-0">
                                    <p className="font-arial hint-text small pull-left letter-sp-normal fs-12 w-auto m-t-5 px-0">{t('auth.enterPassword')}</p>
                                    <div
                                        className="form-group form-group-default bg-white b-transparent-master required">
                                        <label htmlFor="first_name"
                                               className="bold text-uppercase letter-sp-normal fs-12">{t('auth.password')}</label>
                                        <input id="password" name="password" type="password" className="form-control"
                                               required/>
                                    </div>
                                </div>
                                <div className="col-12 col-md-12 p-0">
                                    <button id="contact_submit"
                                            className="btn btn-design-color text-uppercase letter-sp-normal fw-normal w-100"
                                            disabled={false}
                                            style={{padding: '6px 17px'}}>
                                    <span>{t('common.submit')}
                                        {
                                            formSubmitting ?
                                                <FontAwesomeIcon icon={faSpinner} spin className={'m-l-5 square-icon'}/>
                                                :
                                                <FontAwesomeIcon icon={fasAngleRight} className={'m-l-5 square-icon'}/>
                                        }
                                        </span>
                                    </button>
                                    <Link href={'/'}
                                          className="letter-sp-normal fw-normal w-100">
                                        <a className={'w-100 text-center block pt-3'}>
                                            <FontAwesomeIcon icon={fasAngleLeft} className={'m-r-5 square-icon'}/>
                                            {t('auth.backHome')}
                                        </a>
                                    </Link>
                                </div>
                                <div className="col-12 col-md-12 p-0 m-t-20">
                                    {
                                        showResponseMessage ?
                                            <>
                                                {
                                                    formSuccess ?
                                                        <Alert severity="success" sx={{mb: "20px"}}>{t('auth.loginSuccess')}</Alert>
                                                        :
                                                        formSuccess != null ?
                                                            <Alert severity="error" sx={{mb: "20px"}}>{t('auth.wrongPassword')}</Alert>
                                                            :
                                                            <></>
                                                }
                                            </>
                                            :
                                            <>
                                            </>
                                    }
                                </div>
                            </div>
                        </form>
                    </>
                }/>}
            />
        </>
    )
}

export default PasswordProtection